import { useEffect } from "react";

import { AvgVideoChart } from "../../components/charts3";
import { ChartControls } from "../../components/Channel";

import { useUniqueTvData } from "../../hooks/useUniqueTvData";
import { useDaysSorted } from "../../hooks/useDaysSorted";
import { useDateInputs } from "../../hooks/useDateInputs";

import { useAvgVideoConsumption } from "../../hooks/useAvgVideoConsumption";
import { useUserJourneyLogger } from "../../hooks/useUserJourneyLogger"; // ✅ LOGGER

export default function ChannelAvgVideo({
  channelId,
  channelInfo,
  rawVideo,
  refreshKey,
  refreshEnabled,
  setRefreshEnabled,
  refreshIntervalMin,
  setRefreshIntervalMin,
  refreshCountdown,
  manualRefresh
}) {
  const MODE = "day";

  const { logPageChange, logTimeframeChange } = useUserJourneyLogger({
    channelId,
    channelName: channelInfo?.name || channelInfo?.n || "unknown",
  });

  /* =========================
     PAGE LOG (ONCE)
  ========================= */
  useEffect(() => {
    logPageChange({
      chartType: "avgvidconsumption",
      mode: "default",
    });
  }, [logPageChange]);

  /* =========================
     TIMEFRAME LOG (STATIC DAY)
  ========================= */
  useEffect(() => {
    logTimeframeChange({
      chartType: "avgvidconsumption",
      timeframeValue: 1, // day
      timeframeLabel: "day",
    });
  }, [logTimeframeChange]);

  /* =========================
     DATA PIPELINE (UNCHANGED)
  ========================= */

  const sortedKeys = useDaysSorted(rawVideo);

  const dates = useDateInputs(sortedKeys, MODE);

  const { data: uniqueTvData } = useUniqueTvData(
    channelId,
    dates.startDateInput,
    dates.endDateInput,
    refreshKey
  );

  const series = useAvgVideoConsumption({
    rawVideo,
    uniqueTvData,
    sortedVideoKeys: sortedKeys,
    startDateInput: dates.startDateInput,
    endDateInput: dates.endDateInput,
  });

  return (
    <>
      <ChartControls
        channelId={channelId}
        mode={MODE}
        hideModeButtons
        startDateInput={dates.startDateInput}
        endDateInput={dates.endDateInput}
        onStartDateChange={dates.setStartDateInput}
        onEndDateChange={dates.setEndDateInput}
        refreshEnabled={refreshEnabled}
        onRefreshToggle={setRefreshEnabled}
        refreshIntervalMin={refreshIntervalMin}
        onRefreshIntervalChange={setRefreshIntervalMin}
        countdown={refreshCountdown}
        onManualRefresh={manualRefresh}
      />

      <div className="chart-box">
        {series.length > 0 ? (
          <AvgVideoChart
            series={series}
            mode="day"
            refreshKey={refreshKey}
          />        
        ) : (
          <div style={{ padding: 40, opacity: 0.4 }}>(no data)</div>
        )}
      </div>
    </>
  );
}
